import { Window, CapacitorInfo } from '@/types/window'
import { Platform } from '@/constants/app'

export const isCapacitorEnvironment = (
  capacitor = (window as Window).capacitor
): capacitor is CapacitorInfo =>
  capacitor !== undefined && capacitor.isNative === true

export const isPlatformIOS = () => {
  const capacitor = (window as Window).capacitor

  return (
    isCapacitorEnvironment(capacitor) && capacitor.platform === Platform.IOS
  )
}

export const isPlatformAndroid = () => {
  const capacitor = (window as Window).capacitor

  return (
    isCapacitorEnvironment(capacitor) && capacitor.platform === Platform.ANDROID
  )
}
